import { api } from '~/services/api';
import { AxiosError } from 'axios';
import ICustomAxiosRequestConfig from '~/services/custom/ICustomAxiosRequestConfig';

export type LineDataProps = {
  id: string;
  unit_id: string;
  name: string;
  mobile: number;
  email: string;
  people: number;
  code: number;
  preferential: boolean;
  info: string;
  table: number;
  trackingUrl: string;
  position: number;
  source: string;
  status: string;
  created_at: string;
  updated_at: string;
  notifications: { created_at: string; id: string; status: string }[];
};

type LineDataParams = {
  shortId: string;
};

type GetLineDataProps = {
  data?: LineDataProps;
  status?: number;
  message?: string;
};

type LineDataOptions = {
  initialData?: {
    data: LineDataProps;
  };
  keepPreviousData?: boolean;
};

export const getLineData = async (
  params?: LineDataParams,
  serverSide?: { serverSide: boolean }
): Promise<GetLineDataProps> => {
  try {
    const { shortId } = params as LineDataParams;
    const { data, status } = await api.get(`/line/v1/widgets/${shortId}`, {
      serverSide,
    } as ICustomAxiosRequestConfig);

    return {
      data: data.data,
      status,
    };
  } catch (err) {
    const error = err as AxiosError;

    return {
      message: (error.response?.data as any).message,
      status: error.response?.status,
    };
  }
};
